<template>
  <div class="md:max-h-screen">
    <h3 class="my-15">
      Choix du modèle
    </h3>


    <!-- BEGIN CV TYPE CLASSIC -->
    <div
      class="grid grid-cols-1 md:grid-cols-3 justify-center md:gap-x-10 gap-y-10 md:gap-y-0"
      v-if="type === constants.CV_TYPES.BASIC"
    >
      <!-- BEGIN BASIC 1 -->
      <div class="col-span-1 flex flex-col space-y-3.5">
        <div
          class="relative cursor-pointer w-full"
          @click="checkModel('Basic')"
        >
          <img 
            :src="
              colors.Basic === 'yellow' 
                ? '/assets/img/cv/cv_classic_1_yellow.png'
                : colors.Basic === 'pink'
                  ? '/assets/img/cv/cv_classic_1_pink.png'
                  : colors.Basic === 'teal'
                    ? '/assets/img/cv/cv_classic_1_teal.png'
                    : colors.Basic === 'orange'
                      ? '/assets/img/cv/cv_classic_1_orange.png'
                      : colors.Basic === 'gray'
                        ? '/assets/img/cv/cv_classic_1_grey.png'
                        : '/assets/img/cv/cv_classic_1_teal.png'
            "  
            class="object-scale-down" 
            :class="{
              'shadow-gray': model != 'Basic',
              'border-4 border-teal-600': model === 'Basic'
            }"
          />
          <div 
            v-if="model === 'Basic'" 
            class="absolute w-8 h-8 rounded-full 
                            flex justify-center items-center 
                            bg-teal-600 text-white
                            -top-3 right-5
                        "
          >
            <icon name="checkmark" />
          </div>
        </div>
        <div class="flex space-x-4 justify-center">
          <checkbox-indigo
            name="Basic-yellow"
            :value="colors.Basic === 'yellow'"
            @input="(newValue) => {checkColor('Basic', 'yellow', newValue)}"
            color-border="border-yellow-600"
            color-checked="bg-yellow-600"
            color-unchecked="bg-yellow-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-pink"
            :value="colors.Basic === 'pink'"
            @input="(newValue) => {checkColor('Basic', 'pink', newValue)}"
            color-border="border-pink-600"
            color-checked="bg-pink-600"
            color-unchecked="bg-pink-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-teal"
            :value="colors.Basic === 'teal'"
            @input="(newValue) => {checkColor('Basic', 'teal', newValue)}"
            color-border="border-teal-600"
            color-checked="bg-teal-600"
            color-unchecked="bg-teal-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-orange"
            :value="colors.Basic === 'orange'"
            @input="(newValue) => {checkColor('Basic', 'orange', newValue)}"
            color-border="border-orange-600"
            color-checked="bg-orange-600"
            color-unchecked="bg-orange-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-gray"
            :value="colors.Basic === 'gray'"
            @input="(newValue) => {checkColor('Basic', 'gray', newValue)}"
            color-border="border-gray-600"
            color-checked="bg-gray-600"
            color-unchecked="bg-gray-100"
            :not-click-to-false="true"
          />
        </div>
      </div>
      <!-- END BASIC 1 -->

      <!-- BEGIN BASIC 2 -->
      <div class="col-span-1 flex flex-col space-y-3.5">
        <div
          class="relative cursor-pointer w-full"
          @click="checkModel('Basic2')"
        >
          <img 
            :src="
              colors.Basic2 === 'yellow' 
                ? '/assets/img/cv/cv_classic_2_yellow.png'
                : colors.Basic2 === 'pink'
                  ? '/assets/img/cv/cv_classic_2_pink.png'
                  : colors.Basic2 === 'teal'
                    ? '/assets/img/cv/cv_classic_2_teal.png'
                    : colors.Basic2 === 'orange'
                      ? '/assets/img/cv/cv_classic_2_orange.png'
                      : colors.Basic2 === 'gray'
                        ? '/assets/img/cv/cv_classic_2_grey.png'
                        : '/assets/img/cv/cv_classic_2_teal.png'
            " 
            class="object-scale-down" 
            :class="{
              'shadow-gray': model != 'Basic2',
              'border-4 border-teal-600': model === 'Basic2'
            }"
          />


          <div 
            v-if="model === 'Basic2'" 
            class="absolute w-8 h-8 rounded-full 
                            flex justify-center items-center 
                            bg-teal-600 text-white
                            -top-3 right-5
                        "
          >
            <icon name="checkmark" />
          </div>
        </div>
        <div class="flex space-x-4 justify-center">
          <checkbox-indigo
            name="Basic-yellow"
            :value="colors.Basic2 === 'yellow'"
            @input="(newValue) => {checkColor('Basic2', 'yellow', newValue)}"
            color-border="border-yellow-600"
            color-checked="bg-yellow-600"
            color-unchecked="bg-yellow-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-pink"
            :value="colors.Basic2 === 'pink'"
            @input="(newValue) => {checkColor('Basic2', 'pink', newValue)}"
            color-border="border-pink-600"
            color-checked="bg-pink-600"
            color-unchecked="bg-pink-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-teal"
            :value="colors.Basic2 === 'teal'"
            @input="(newValue) => {checkColor('Basic2', 'teal', newValue)}"
            color-border="border-teal-600"
            color-checked="bg-teal-600"
            color-unchecked="bg-teal-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-orange"
            :value="colors.Basic2 === 'orange'"
            @input="(newValue) => {checkColor('Basic2', 'orange', newValue)}"
            color-border="border-orange-600"
            color-checked="bg-orange-600"
            color-unchecked="bg-orange-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-gray"
            :value="colors.Basic2 === 'gray'"
            @input="(newValue) => {checkColor('Basic2', 'gray', newValue)}"
            color-border="border-gray-600"
            color-checked="bg-gray-600"
            color-unchecked="bg-gray-100"
            :not-click-to-false="true"
          />
        </div>
      </div>
      <!-- END BASIC 2 -->

      <!-- BEGIN BASIC 3 -->
      <div class="col-span-1 flex flex-col space-y-3.5">
        <div
          class="relative cursor-pointer w-full"
          @click="checkModel('Basic3')"
        >
          <img 
            :src="
              colors.Basic3 === 'yellow' 
                ? '/assets/img/cv/cv_classic_3_yellow.png'
                : colors.Basic3 === 'pink'
                  ? '/assets/img/cv/cv_classic_3_pink.png'
                  : colors.Basic3 === 'teal'
                    ? '/assets/img/cv/cv_classic_3_teal.png'
                    : colors.Basic3 === 'orange'
                      ? '/assets/img/cv/cv_classic_3_orange.png'
                      : colors.Basic3 === 'gray'
                        ? '/assets/img/cv/cv_classic_3_grey.png'
                        : '/assets/img/cv/cv_classic_3_teal.png'
            " 
            class="object-scale-down" 
            :class="{
              'shadow-gray': model != 'Basic3',
              'border-4 border-teal-600': model === 'Basic3'
            }"
          />

          <div 
            v-if="model === 'Basic3'" 
            class="absolute w-8 h-8 rounded-full 
                            flex justify-center items-center 
                            bg-teal-600 text-white
                            -top-3 right-5
                        "
          >
            <icon name="checkmark" />
          </div>
        </div>
        <div class="flex space-x-4 justify-center">
          <checkbox-indigo
            name="Basic-yellow"
            :value="colors.Basic3 === 'yellow'"
            @input="(newValue) => {checkColor('Basic3', 'yellow', newValue)}"
            color-border="border-yellow-600"
            color-checked="bg-yellow-600"
            color-unchecked="bg-yellow-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-pink"
            :value="colors.Basic3 === 'pink'"
            @input="(newValue) => {checkColor('Basic3', 'pink', newValue)}"
            color-border="border-pink-600"
            color-checked="bg-pink-600"
            color-unchecked="bg-pink-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-teal"
            :value="colors.Basic3 === 'teal'"
            @input="(newValue) => {checkColor('Basic3', 'teal', newValue)}"
            color-border="border-teal-600"
            color-checked="bg-teal-600"
            color-unchecked="bg-teal-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-orange"
            :value="colors.Basic3 === 'orange'"
            @input="(newValue) => {checkColor('Basic3', 'orange', newValue)}"
            color-border="border-orange-600"
            color-checked="bg-orange-600"
            color-unchecked="bg-orange-100"
            :not-click-to-false="true"
          />
          <checkbox-indigo
            name="Basic-gray"
            :value="colors.Basic3 === 'gray'"
            @input="(newValue) => {checkColor('Basic3', 'gray', newValue)}"
            color-border="border-gray-600"
            color-checked="bg-gray-600"
            color-unchecked="bg-gray-100"
            :not-click-to-false="true"
          />
        </div>
      </div>
      <!-- END BASIC 3 -->
    </div>
    <!-- END CV TYPE CLASSIC -->

    <!-- BEGIN CV TYPE DASHBOARD -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-y-5 md:justify-center w-full"
      v-else-if="type === constants.CV_TYPES.DASHBOARD"
    >
      <!-- BEGIN DASHBOARD 1 -->
      <div class="col-span-1 flex md:flex-col space-y-3.5 md:px-10">
        <div
          class="w-full relative cursor-pointer"
          @click="checkModel('Dashboard')"
        >
          <img 
            src="/assets/img/cv/cv_dashboard.png" 
            class="object-scale-down" 
            :class="{
              'shadow-gray': model != 'Dashboard',
              'border-4 border-teal-600': model === 'Dashboard'
            }"
          />

          <div 
            v-if="model === 'Dashboard'" 
            class="absolute 
                            bg-teal-600 text-white
                            w-8 h-8 rounded-full 
                            flex justify-center items-center
                            -top-3 right-5
                        "
          >
            <icon name="checkmark" />
          </div>
        </div>
        <div class="space-x-4 justify-center hidden">
          <checkbox-indigo
            v-for="(color, index) in modelColors.Dashboard"
            :key="`color_checkbox_${color}_${index}`"
            :name="`Dashboard-${color}`"
            :value="colors.Dashboard === color"
            @input="(newValue) => {checkColor('Dashboard', color, newValue)}"
            :color-border="`border-${color}-600`"
            :color-checked="`bg-${color}-600`"
            :color-unchecked="`bg-${color}-100`"
            :not-click-to-false="true"
          />
        </div>
      </div>
      <!-- END DASHBOARD 1 -->

      <!-- BEGIN DASHBOARD 2 -->
      <div class="col-span-1 flex md:flex-col space-y-3.5 md:px-10">
        <div
          @click="checkModel('Dashboard2')"
          class="relative cursor-pointer w-full"
        >
          <img 
            src="/assets/img/cv/cv_dashboard-2.png" 
            class="object-scale-down" 
            :class="{
              'shadow-gray': model != 'Dashboard2',
              'border-4 border-teal-600': model === 'Dashboard2'
            }"
          />

          <div 
            v-if="model === 'Dashboard2'" 
            class="absolute 
                            bg-teal-600 text-white
                            w-8 h-8 rounded-full 
                            flex justify-center items-center 
                            -top-3
                            right-5
                        "
          >
            <icon name="checkmark" />
          </div>
        </div>
        <div class="space-x-4 justify-center hidden">
          <checkbox-indigo
            v-for="(color, index) in modelColors.Dashboard"
            :key="`color_checkbox_${color}_${index}`"
            :name="`Dashboard-${color}`"
            :value="colors.Dashboard === color"
            @input="(newValue) => {checkColor('Dashboard', color, newValue)}"
            :color-border="`border-${color}-600`"
            :color-checked="`bg-${color}-600`"
            :color-unchecked="`bg-${color}-100`"
            :not-click-to-false="true"
          />
        </div>
      </div>
      <!-- END DASHBOARD 2 -->
    </div>
    <!-- END CV TYPE DASHBOARD -->
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import ModelPdf from './../pdf/ModelPdf.vue';

import CheckboxIndigo from './../../../components/Inputs/CheckboxIndigo.vue';
import Icon from './../../../components/Icon.vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import Constants from './../../../constants';

export default {
  components:{
    VueHtml2pdf,
    ModelPdf,
    CheckboxIndigo,
    Icon,
  },

  data(){
    return {
      colors:{
        Basic: 'teal',
        Basic2: 'teal',
        Basic3: 'teal',
        Dashboard: 'teal',
        Dashboard2: 'teal',
        Dashboard3: 'teal',
      },
      modelColors: {
        Dashboard: ['yellow', 'pink', 'teal', 'orange', 'gray']
      },
      model:'Basic',
      type: 'basic',

      constants: Constants,
    };
  },

  mounted(){
    let model = this.form.data.shaping.name;
    let color = this.form.data.shaping.color;
    let type = this.form.type;

    this.model = model;
    this.type = type;
    this.colors[model] = color;
  },

  methods:{
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    ...mapMutations({
      SET_WATERMARKHIDDEN: 'curriculumVitae/SET_WATERMARKHIDDEN'
    }),

    checkModel(value){
      this.model = value;
      this.form.data.shaping.name = value;
      this.form.data.shaping.color = this.colors[this.model];
      this.saveDatas();
    },

    checkColor(model, color, value){
      if(!value){
        return;
      }

      this.colors[model] = color;

      if(model != this.model){
        return;
      }
      this.form.data.shaping.color = color;

      this.saveDatas();
    }
  },

  computed:{
    ...mapGetters({
      form: 'curriculumVitae/form',
      watermarkHidden: 'curriculumVitae/watermarkHidden'
    }),
  }
};
</script>
